// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/modern-normalize/modern-normalize.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/the-new-css-reset/css/reset.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./static/assets/images/pexels-pixabay-209831.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&family=Roboto+Condensed:wght@300;400;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --divider-colour: rgba(255, 255, 255, 0.5);
  --font-colour: rgba(255, 255, 255, 0.85);
  --temp-font-colour: rgba(255, 255, 255, 1);
  --font-outline-colour: rgba(0, 0, 0, 0.4);
  /* --search-colour: rgba(255, 255, 255, 0.01); */
  --aa-muted-color-rgb: rgb(255, 255, 255);
  --panel-background: rgba(255, 255, 255, 0.2);
  --aa-background-color-alpha: 0.9;
  --aa-input-background-color-alpha: 0.3;
  --aa-text-color-rgb: 255 255 255;
  --aa-text-color-alpha: 0.9;
  --aa-overlay-color-rgb: 255 255 255;
  --aa-overlay-color-alpha: 1;
}

* {
  margin: 0;
  padding: 0;
  color: var(--font-colour);
  font-weight: 600;

  -webkit-text-stroke: 1px var(--font-outline-colour);
  /* border: 1px solid black; */
}
/* html {
  height: 100vh;
} */
h1 {
  font-size: 1.5rem;
}
h2 {
  font-size: 1.3rem;
  white-space: pre;
}

h3 {
  font-size: 1.05rem;
}

body {
  margin: auto;
  padding-top: 30px;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100%;
  /* -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px); */
  /* position: relative; */
  /* z-index: 10; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  font-family: 'Poppins', sans-serif;
}

main {
  width: 1450px;
  min-width: 1350px;
  max-width: 90vw;
  min-height: 850px;
  max-height: 850px;
  margin: auto;
  display: grid;
  gap: 2%;
  grid-template: minmax(auto, 100%) / 1fr 5fr;
  backdrop-filter: blur(1px);

  padding: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 25px;

  /* z-index: 0; */
}

#side-panel {
  grid-area: 1/1/2/2;
  min-width: 350px;
  max-height: 100%;
  padding: 1rem;
  display: grid;
  grid-template: auto auto / 1fr;

  background-color: var(--panel-background);
  -webkit-backdrop-filter: blur(15px);
  backdrop-filter: blur(15px);
  border-radius: 15px;
}

header {
  grid-area: 1/1/2/4;
  display: flex;
  justify-content: space-between;
  height: 50px;
}

header h1 {
  align-self: center;
}

/* TOP PANEL */
#top-panel {
  display: grid;
  grid-template: minmax(auto, 55px) auto / auto;
  border-bottom: 1.5px solid var(--divider-colour);
}

/* CURRENT-WEATHER */

#current-ctr {
  display: grid;
  grid-template: auto auto auto/ 1fr 1fr;
  align-content: start;
}

#location {
  white-space: normal;
  font-size: 1.2rem;
  overflow-wrap: break-word;
  border-right: 1.5px solid var(--divider-colour);
  /* padding-right: 1rem; */
}

#info {
  grid-area: 1/1/2/3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#info :is(#location, .date-time-ctr) {
  padding: 1rem;
  flex-basis: 50%;
}

.date-time-ctr h2 {
  font-size: 1.1rem;
}

#current-ctr #icon-ctr {
  grid-area: 2/1/3/2;
  align-self: center;
  height: 7rem;
  width: 7rem;
}

#temp-output {
  font-size: 4rem;
  color: var(--temp-font-colour);
  align-self: center;
  grid-area: 2/2/3/3;
}

#feels-ctr {
  grid-area: 3/1/4/3;
  display: grid;
  grid-template: 1fr auto/ 1fr;
}
#feels-ctr .row {
  grid-area: 1/1/2/2;
  display: flex;
  align-items: center;
}

#feels-ctr h3 {
}
#feels-ctr img {
  height: 2.5rem;
  width: 2.5rem;
}
#feels-like {
  grid-area: 2/1/3/2;
  font-size: 2rem;
  padding-left: 0.7rem;
}
/*DAILY FORECAST*/

#daily-forecast {
  display: flex;
  flex-direction: column;
  gap: 10px;
  grid-area: 2/1/3/2;
  margin: 10px;
}

.daily-list {
  /* height: 100%; */
  display: grid;
  grid-auto-flow: row;
  gap: 3%;
}

.card {
  display: grid;
  grid-template-columns: 0.8fr 2fr 1fr;
  gap: 2.5%;
}

.daily-list .col {
  display: flex;
  flex-direction: column;
}

output.date {
  font-size: 0.8rem;
}

.icon {
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;

  border-radius: 4px;
}
.icon img {
  height: 3rem;
  width: 3rem;
}

.temp {
  border-left: 1.5px solid var(--divider-colour);
  justify-content: center;
}
output:is(.high, .low) {
  text-align: right;
}

/* SEARCH FORM  */
#search-form {
  grid-area: 1/1/2/2;
  margin-bottom: 1%;
  color: var(--search-colour);
}
.ais-search-box {
  max-width: none;
  /* color: var(--search-colour); */
}
.aa-Item {
  color: black;
}
/* UNIT TOGGLE*/
#toggle-ctr {
  display: flex;
}

#toggle-ctr img {
  height: 3rem;
  width: 3rem;
}
.switch {
  position: relative;
  display: inline-flex;
  align-self: center;
  align-items: center;
  width: 60px;
  height: 34px;
}

#unit-toggle {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  align-self: center;
  vertical-align: middle;
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: whitesmoke;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}

#unit-toggle:checked + .slider {
  background-color: #2379c083;
}

#unit-toggle:focus + .slider {
  box-shadow: 0 0 1px #2379c083;
}

#unit-toggle:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* input {
  font-size: 1.5rem;
  width: 80%;
  height: 100%;
}

input::placeholder {
  opacity: 0.5;
} */
/* button {
  width: 3rem;
  height: 100%;
  cursor: pointer;
} */

#main-panel {
  grid-area: 1/2/2/3;

  height: 100%;
  width: 100%;
  display: grid;
  grid-template: auto auto auto/ 1fr 3fr;

  gap: 15px;
}

#current-conditions h2 {
  font-size: 2.5rem;
}

/* WEATHER HIGHLIGHTS  */
#highlights {
  grid-area: 2/2/3/3;
  display: flex;
  justify-content: flex-end;
}
#highlights ul {
  display: grid;
  grid-template: 1fr 1fr / repeat(4, 1fr);

  align-self: center;
}

#highlights li {
  display: grid;
  grid-template: 1fr 1fr/1fr 3fr;
}
#highlights label {
  font-size: 0.8rem;
}
#highlights img {
  height: 3rem;
  width: 3rem;
  grid-area: 1/1/3/2;
}

#description-output {
  font-size: 2rem;
  margin-left: 2rem;
}

#charts-ctr {
  grid-area: 3/1/4/3;
  justify-self: center;
  height: 96%;

  width: 100%;
  display: flex;
  justify-content: center;

  padding-top: 15px;
  background-color: var(--panel-background);
  border-radius: 10px;
  /* border: 1px solid rgba(255, 255, 255, 0.3); */
}

.chart-ctr {
  border: none;
  width: 90%;
  display: flex;
  height: 100%;
}

.colSmall {
  border: none;

  width: 35px;
}

.colLarge {
  border: none;
  max-width: 100%;
  overflow-x: scroll;
}
.box {
  border: none;
  width: calc(2000px - 28px);
  height: 100%;
}
canvas {
  border: none;
}

footer {
  min-height: 7vh;
  max-height: 2vh;
  background: rgba(0 0, 0, 00);
  font-weight: 900;
  font-size: 30px;
  color: whitesmoke;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px;
}

footer img {
  height: 3.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAIA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;EACzC,gDAAgD;EAChD,wCAAwC;EACxC,4CAA4C;EAC5C,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,0BAA0B;EAC1B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,gBAAgB;;EAEhB,mDAAmD;EACnD,6BAA6B;AAC/B;AACA;;GAEG;AACH;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,yDAAyE;EACzE,qBAAqB;EACrB;+BAC6B;EAC7B,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,OAAO;EACP,2CAA2C;EAC3C,0BAA0B;;EAE1B,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;;EAEnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,8BAA8B;;EAE9B,yCAAyC;EACzC,mCAAmC;EACnC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;AACA;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA,iBAAiB;;AAEjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;;EAEvB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,YAAY;AACd;AACA,eAAe;AACf;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;;;;;;;;GAQG;AACH;;;;GAIG;;AAEH;EACE,kBAAkB;;EAElB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sCAAsC;;EAEtC,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uCAAuC;;EAEvC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;;EAEX,WAAW;EACX,aAAa;EACb,uBAAuB;;EAEvB,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;;EAEZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["@import '~modern-normalize/modern-normalize.css';\n@import '~the-new-css-reset/css/reset.css';\n@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&family=Roboto+Condensed:wght@300;400;700&display=swap);\n\n:root {\n  --divider-colour: rgba(255, 255, 255, 0.5);\n  --font-colour: rgba(255, 255, 255, 0.85);\n  --temp-font-colour: rgba(255, 255, 255, 1);\n  --font-outline-colour: rgba(0, 0, 0, 0.4);\n  /* --search-colour: rgba(255, 255, 255, 0.01); */\n  --aa-muted-color-rgb: rgb(255, 255, 255);\n  --panel-background: rgba(255, 255, 255, 0.2);\n  --aa-background-color-alpha: 0.9;\n  --aa-input-background-color-alpha: 0.3;\n  --aa-text-color-rgb: 255 255 255;\n  --aa-text-color-alpha: 0.9;\n  --aa-overlay-color-rgb: 255 255 255;\n  --aa-overlay-color-alpha: 1;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  color: var(--font-colour);\n  font-weight: 600;\n\n  -webkit-text-stroke: 1px var(--font-outline-colour);\n  /* border: 1px solid black; */\n}\n/* html {\n  height: 100vh;\n} */\nh1 {\n  font-size: 1.5rem;\n}\nh2 {\n  font-size: 1.3rem;\n  white-space: pre;\n}\n\nh3 {\n  font-size: 1.05rem;\n}\n\nbody {\n  margin: auto;\n  padding-top: 30px;\n  height: 100vh;\n  background-image: url('./static/assets/images/pexels-pixabay-209831.jpg');\n  background-size: 100%;\n  /* -webkit-backdrop-filter: blur(3px);\n  backdrop-filter: blur(3px); */\n  /* position: relative; */\n  /* z-index: 10; */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 10px;\n  font-family: 'Poppins', sans-serif;\n}\n\nmain {\n  width: 1450px;\n  min-width: 1350px;\n  max-width: 90vw;\n  min-height: 850px;\n  max-height: 850px;\n  margin: auto;\n  display: grid;\n  gap: 2%;\n  grid-template: minmax(auto, 100%) / 1fr 5fr;\n  backdrop-filter: blur(1px);\n\n  padding: 1rem;\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-radius: 25px;\n\n  /* z-index: 0; */\n}\n\n#side-panel {\n  grid-area: 1/1/2/2;\n  min-width: 350px;\n  max-height: 100%;\n  padding: 1rem;\n  display: grid;\n  grid-template: auto auto / 1fr;\n\n  background-color: var(--panel-background);\n  -webkit-backdrop-filter: blur(15px);\n  backdrop-filter: blur(15px);\n  border-radius: 15px;\n}\n\nheader {\n  grid-area: 1/1/2/4;\n  display: flex;\n  justify-content: space-between;\n  height: 50px;\n}\n\nheader h1 {\n  align-self: center;\n}\n\n/* TOP PANEL */\n#top-panel {\n  display: grid;\n  grid-template: minmax(auto, 55px) auto / auto;\n  border-bottom: 1.5px solid var(--divider-colour);\n}\n\n/* CURRENT-WEATHER */\n\n#current-ctr {\n  display: grid;\n  grid-template: auto auto auto/ 1fr 1fr;\n  align-content: start;\n}\n\n#location {\n  white-space: normal;\n  font-size: 1.2rem;\n  overflow-wrap: break-word;\n  border-right: 1.5px solid var(--divider-colour);\n  /* padding-right: 1rem; */\n}\n\n#info {\n  grid-area: 1/1/2/3;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n#info :is(#location, .date-time-ctr) {\n  padding: 1rem;\n  flex-basis: 50%;\n}\n\n.date-time-ctr h2 {\n  font-size: 1.1rem;\n}\n\n#current-ctr #icon-ctr {\n  grid-area: 2/1/3/2;\n  align-self: center;\n  height: 7rem;\n  width: 7rem;\n}\n\n#temp-output {\n  font-size: 4rem;\n  color: var(--temp-font-colour);\n  align-self: center;\n  grid-area: 2/2/3/3;\n}\n\n#feels-ctr {\n  grid-area: 3/1/4/3;\n  display: grid;\n  grid-template: 1fr auto/ 1fr;\n}\n#feels-ctr .row {\n  grid-area: 1/1/2/2;\n  display: flex;\n  align-items: center;\n}\n\n#feels-ctr h3 {\n}\n#feels-ctr img {\n  height: 2.5rem;\n  width: 2.5rem;\n}\n#feels-like {\n  grid-area: 2/1/3/2;\n  font-size: 2rem;\n  padding-left: 0.7rem;\n}\n/*DAILY FORECAST*/\n\n#daily-forecast {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  grid-area: 2/1/3/2;\n  margin: 10px;\n}\n\n.daily-list {\n  /* height: 100%; */\n  display: grid;\n  grid-auto-flow: row;\n  gap: 3%;\n}\n\n.card {\n  display: grid;\n  grid-template-columns: 0.8fr 2fr 1fr;\n  gap: 2.5%;\n}\n\n.daily-list .col {\n  display: flex;\n  flex-direction: column;\n}\n\noutput.date {\n  font-size: 0.8rem;\n}\n\n.icon {\n  background-color: rgba(255, 255, 255, 0.5);\n  display: flex;\n  justify-content: center;\n\n  border-radius: 4px;\n}\n.icon img {\n  height: 3rem;\n  width: 3rem;\n}\n\n.temp {\n  border-left: 1.5px solid var(--divider-colour);\n  justify-content: center;\n}\noutput:is(.high, .low) {\n  text-align: right;\n}\n\n/* SEARCH FORM  */\n#search-form {\n  grid-area: 1/1/2/2;\n  margin-bottom: 1%;\n  color: var(--search-colour);\n}\n.ais-search-box {\n  max-width: none;\n  /* color: var(--search-colour); */\n}\n.aa-Item {\n  color: black;\n}\n/* UNIT TOGGLE*/\n#toggle-ctr {\n  display: flex;\n}\n\n#toggle-ctr img {\n  height: 3rem;\n  width: 3rem;\n}\n.switch {\n  position: relative;\n  display: inline-flex;\n  align-self: center;\n  align-items: center;\n  width: 60px;\n  height: 34px;\n}\n\n#unit-toggle {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  border-radius: 34px;\n}\n\n.slider:before {\n  align-self: center;\n  vertical-align: middle;\n  position: absolute;\n  content: '';\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: whitesmoke;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\n#unit-toggle:checked + .slider {\n  background-color: #2379c083;\n}\n\n#unit-toggle:focus + .slider {\n  box-shadow: 0 0 1px #2379c083;\n}\n\n#unit-toggle:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* input {\n  font-size: 1.5rem;\n  width: 80%;\n  height: 100%;\n}\n\ninput::placeholder {\n  opacity: 0.5;\n} */\n/* button {\n  width: 3rem;\n  height: 100%;\n  cursor: pointer;\n} */\n\n#main-panel {\n  grid-area: 1/2/2/3;\n\n  height: 100%;\n  width: 100%;\n  display: grid;\n  grid-template: auto auto auto/ 1fr 3fr;\n\n  gap: 15px;\n}\n\n#current-conditions h2 {\n  font-size: 2.5rem;\n}\n\n/* WEATHER HIGHLIGHTS  */\n#highlights {\n  grid-area: 2/2/3/3;\n  display: flex;\n  justify-content: flex-end;\n}\n#highlights ul {\n  display: grid;\n  grid-template: 1fr 1fr / repeat(4, 1fr);\n\n  align-self: center;\n}\n\n#highlights li {\n  display: grid;\n  grid-template: 1fr 1fr/1fr 3fr;\n}\n#highlights label {\n  font-size: 0.8rem;\n}\n#highlights img {\n  height: 3rem;\n  width: 3rem;\n  grid-area: 1/1/3/2;\n}\n\n#description-output {\n  font-size: 2rem;\n  margin-left: 2rem;\n}\n\n#charts-ctr {\n  grid-area: 3/1/4/3;\n  justify-self: center;\n  height: 96%;\n\n  width: 100%;\n  display: flex;\n  justify-content: center;\n\n  padding-top: 15px;\n  background-color: var(--panel-background);\n  border-radius: 10px;\n  /* border: 1px solid rgba(255, 255, 255, 0.3); */\n}\n\n.chart-ctr {\n  border: none;\n  width: 90%;\n  display: flex;\n  height: 100%;\n}\n\n.colSmall {\n  border: none;\n\n  width: 35px;\n}\n\n.colLarge {\n  border: none;\n  max-width: 100%;\n  overflow-x: scroll;\n}\n.box {\n  border: none;\n  width: calc(2000px - 28px);\n  height: 100%;\n}\ncanvas {\n  border: none;\n}\n\nfooter {\n  min-height: 7vh;\n  max-height: 2vh;\n  background: rgba(0 0, 0, 00);\n  font-weight: 900;\n  font-size: 30px;\n  color: whitesmoke;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-right: 10px;\n}\n\nfooter img {\n  height: 3.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
